import logo from './logo.svg';
// import './App.css';
import { Route, Router, Routes } from 'react-router-dom';
import Registration from './pages/Registration';
import VerifyEmail from './pages/verifyEmail';
import Credentials from './pages/Credentials';
import Login from './pages/Login';
import Pricing from './pages/pricing';
import Checkout from './pages/Checkout';
import Dashboard from './pages/Dashboard';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Terms from './pages/Terms';
import AudioTranscribeDocs from './pages/Documentation/AudioTranscribeDocs';
import Usage from './pages/Dashboard/Usage';
import Alerts from './pages/Dashboard/Alerts';
import ForgotPassword from './pages/ForgotPassword';
import MaintenanceBanner from "./pages/MaintenanceBanner";
function App() {
  return (
    <>
      <MaintenanceBanner />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/Home' element={<Home />} />
        <Route path='/Login' element={<Login />} />
        <Route path='/Register' element={<Registration />} />
        <Route path='/VerifyEmail' element={<VerifyEmail />} />
        <Route path='/UpdateCredentials' element={<Credentials />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        <Route path='/Pricing' element={<Pricing />} />
        {/* <Route path='/Checkout' element={<Checkout />} /> */}
        <Route path='/Dashboard' element={<Dashboard />} />
        {/* <Route path='/Usage/:userSubscriptionID' element={<Usage />} /> */}
        <Route path='/Alerts' element={<Alerts />} />
        <Route path='/AboutUs' element={<AboutUs />} />
        <Route path='/Terms' element={<Terms />} />
        <Route path='/dev-docs/AudioTranscription' element={<AudioTranscribeDocs />} />
      </Routes>
    </>
  );
}

export default App;
